import React from "react";
import { get } from "lodash";
import { Close, Header, Modal } from "MODULES/shared/components/Modal";
import { useCurrentUser } from "APP_ROOT/hooks";
import {
  ULTIMATE_CONSIGNEE_CCS,
  ULTIMATE_CONSIGNEE_FORM_BODY,
  ULTIMATE_CONSIGNEE_FORM_SUBJECT
} from "MODULES/companies/constants";
import Form from "./Form";

function RequestUltimateConsigneeModal({ close, open, company }) {
  const currentUser = useCurrentUser();

  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Request Ultimate Consignee Form</h4>
      </Header>
      <Form
        company={company}
        close={close}
        initialValues={{
          from: currentUser.email,
          ccs: get(currentUser.tenant, ULTIMATE_CONSIGNEE_CCS),
          subject: get(currentUser.tenant, ULTIMATE_CONSIGNEE_FORM_SUBJECT),
          body: get(currentUser.tenant, ULTIMATE_CONSIGNEE_FORM_BODY)
        }}
        enableReinitialize
      />
    </Modal>
  );
}

export default RequestUltimateConsigneeModal;



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/RequestUltimateConsignee/RequestUltimateConsigneeModal.jsx